/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Pod_Photo_TitleInputs */

const vi_order_pod_photo_title = /** @type {(inputs: Order_Pod_Photo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh giao hàng từ camera xe`)
};

/**

* @param {Order_Pod_Photo_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_pod_photo_title = /** @type {((inputs?: Order_Pod_Photo_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Pod_Photo_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_pod_photo_title(inputs)
});